import styles from './RouteFallback.module.css';

/** Lightweight route-loading fallback for lazy pages — brand spinner, no layout shift. */
export function RouteFallback() {
  return (
    <div className={styles.wrap} role="status" aria-label="Loading">
      <div className={styles.spinner} />
    </div>
  );
}

export default RouteFallback;
